import React from "react";
import {Col, Row} from "react-bootstrap";
import {Election} from "./Election";

type HeaderProps = {
    election: Election
}

const Header = (props:HeaderProps) => {
    return (
        <Row className={"justify-content-center my-3"}>
            <Col xs={12} sm={11} md={9} lg={7} className={"text-center"} style={{height:'120px'}}>
                <img className="img-fluid img-vmax-100" style={{maxHeight:"140px"}} src={props.election.configuration.logo_url} alt="Logo"/>
            </Col>
        </Row>
    );
  }

export default Header;
